import LegalLayout, { LegalSection } from "@/components/LegalLayout";

const linkClass = "font-medium text-orange2 underline underline-offset-2 transition-colors hover:text-cream";

const Integritetspolicy = () => (
  <LegalLayout title="Integritetspolicy" updated="1 juli 2026" testId="integritetspolicy-page">
    <LegalSection title="1. Personuppgiftsansvarig">
      <p>
        Tillvia (”vi”, ”oss”) är personuppgiftsansvarig för behandlingen av de personuppgifter du lämnar till oss via
        denna webbplats, tillvia.se. Du når oss alltid på{" "}
        <a href="mailto:info@tillvia.se" className={linkClass}>
          info@tillvia.se
        </a>
        .
      </p>
    </LegalSection>

    <LegalSection title="2. Vilka personuppgifter samlar vi in?">
      <p>
        När du skickar in vårt kontakt- och bokningsformulär samlar vi in de uppgifter du själv fyller i: företagsnamn,
        ditt namn, e-postadress, telefonnummer, företagets hemsida (om du anger den), vad du behöver hjälp med, din
        beskrivning av behovet, ungefärlig budget, önskat mötesformat, önskat datum samt eventuellt övrigt meddelande.
      </p>
    </LegalSection>

    <LegalSection title="3. Varför behandlar vi dina uppgifter?">
      <p>
        Uppgifterna används för att vi ska kunna kontakta dig angående din förfrågan, boka och genomföra möten samt ta
        fram offert och genomföra beställda tjänster. Den rättsliga grunden är intresseavvägning samt åtgärder som
        vidtas på din begäran inför ett eventuellt avtal (artikel 6.1 b och f i GDPR).
      </p>
    </LegalSection>

    <LegalSection title="4. Hur lagras uppgifterna och hur länge?">
      <p>
        Dina uppgifter sparas säkert i vår databas som säkerhetskopia och skickas även till vår e-postlåda via vår
        e-postleverantör Resend, som agerar personuppgiftsbiträde. Vi sparar uppgifterna så länge ärendet är aktuellt
        och raderar dem senast 24 månader efter senaste kontakten, om ingen affärsrelation uppstår.
      </p>
    </LegalSection>

    <LegalSection title="5. Delar vi uppgifter med andra?">
      <p>
        Vi säljer aldrig dina uppgifter och delar dem inte med tredje part för marknadsföring. Uppgifter delas endast
        med de tekniska leverantörer som behövs för att driva webbplatsen och vår e-post (hosting- och
        e-postleverantörer), och alltid under personuppgiftsbiträdesavtal.
      </p>
    </LegalSection>

    <LegalSection title="6. Dina rättigheter">
      <p>
        Du har rätt att begära tillgång till, rättelse eller radering av dina personuppgifter, att begränsa
        behandlingen, att invända mot behandlingen samt att få ut dina uppgifter (dataportabilitet). Kontakta oss på{" "}
        <a href="mailto:info@tillvia.se" className={linkClass}>
          info@tillvia.se
        </a>{" "}
        så hjälper vi dig.
      </p>
      <p>
        Om du anser att vi behandlar dina uppgifter felaktigt har du rätt att lämna klagomål till
        Integritetsskyddsmyndigheten (IMY), imy.se.
      </p>
    </LegalSection>

    <LegalSection title="7. Kontakt">
      <p>
        Har du frågor om hur vi hanterar personuppgifter? Kontakta Tillvia på{" "}
        <a href="mailto:info@tillvia.se" className={linkClass}>
          info@tillvia.se
        </a>
        .
      </p>
    </LegalSection>
  </LegalLayout>
);

export default Integritetspolicy;
